import { TGlobalStores } from '.';
import { BUILD_PROPERTIES } from '../constant/buildProperties';
import { DEFAULT_SEP_WALL_THICKNESS } from '../constant/wall';
import { ESeparateWallType } from '../data/separateWall/SeparateWall';
import { IHistoryParams, INotHistoryParams, ISystemParams } from '../types';
import { BaseObjectStore } from './base/baseObjectStore';

export class ParamStore {
  private _baseObjectStore: BaseObjectStore<IHistoryParams>;
  private _notHistoryParams: Partial<INotHistoryParams> = {};

  constructor(gs: TGlobalStores) {
    this._baseObjectStore = new BaseObjectStore<IHistoryParams>(gs, ParamStore.createHistoryDefault());
    this._notHistoryParams = ParamStore.createNotHistoryDefault();
  }

  static createHistoryDefault() {
    return {
      layerHeight: 3000,
      offGround: 0
    };
  }

  static createNotHistoryDefault() {
    return {
      wallThickness: BUILD_PROPERTIES.WALL.DEFAULT_THICKNESS,
      separateWallThickness: DEFAULT_SEP_WALL_THICKNESS,
      separateWallType: ESeparateWallType.SolidTabletWall,
      floorPlanConfig: null
    };
  }

  get layerHeight() {
    return this._baseObjectStore.get('layerHeight');
  }
  get offGround() {
    return this._baseObjectStore.get('offGround');
  }

  get wallThickness() {
    return this._notHistoryParams.wallThickness as number;
  }
  get separateWallThickness() {
    return this._notHistoryParams.separateWallThickness as number;
  }
  get separateWallType() {
    return this._notHistoryParams.separateWallType as ESeparateWallType;
  }
  get floorPlanConfig() {
    return this._notHistoryParams.floorPlanConfig as ISystemParams['floorPlanConfig'];
  }

  updateHistoryParams(params: Partial<IHistoryParams>) {
    this._baseObjectStore.update(params);
  }
  updateNotHistoryParams(params: Partial<INotHistoryParams>) {
    this._notHistoryParams = { ...this._notHistoryParams, ...params };
  }

  getDatas() {
    return {
      layerHeight: this.layerHeight,
      offGround: this.offGround,
      wallThickness: this.wallThickness,
      separateWallThickness: this.separateWallThickness,
      separateWallType: this.separateWallType,
      floorPlanConfig: this.floorPlanConfig
    };
  }

  coverDatas(systemParams: ISystemParams) {
    if (!systemParams) return;

    this.updateHistoryParams({
      layerHeight: systemParams.layerHeight || this.layerHeight,
      offGround: systemParams.offGround || this.offGround
    });
    this.updateNotHistoryParams({
      floorPlanConfig: systemParams.floorPlanConfig ?? this.floorPlanConfig,
      wallThickness: systemParams.wallThickness || this.wallThickness,
      separateWallThickness: systemParams.separateWallThickness || this.separateWallThickness,
      separateWallType: systemParams.separateWallType || this.separateWallType
    });
  }
}
